import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faAngleDown);
library.add(faAngleUp);

const CaretDownIcon: React.FC = () => {
  return (
    <FontAwesomeIcon icon="angle-down" viewBox="150 150 160 250" style={{ 'color': '#FF4401' }} />
  );
};

const CaretUpIcon: React.FC = () => {
  return (
    <FontAwesomeIcon icon="angle-up" viewBox="150 150 160 250" style={{ 'color': '#FF4401' }} />
  );
};

export { CaretDownIcon, CaretUpIcon };
